export default __webpack_public_path__ + "static/media/ic_check.e179ca0a.svg";